module.exports = __webpack_public_path__ + "static/media/orderDetailsCollectorIdIcon.b5afa821.svg";